var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.97 10.074c.746 0 1.434-.186 2.063-.56a4.141 4.141 0 001.492-1.503c.366-.63.55-1.317.55-2.063 0-.746-.184-1.434-.55-2.063a4.057 4.057 0 00-1.492-1.493 4.032 4.032 0 00-2.063-.548c-.746 0-1.434.183-2.063.548-.63.366-1.13.864-1.504 1.493a3.971 3.971 0 00-.56 2.063c0 .746.187 1.434.56 2.063a4.23 4.23 0 001.504 1.503c.629.374 1.317.56 2.063.56zm5.487 0L16 14.617 14.617 16l-4.543-4.565v-.724l-.263-.242a5.427 5.427 0 01-1.767 1.043 6.037 6.037 0 01-2.074.362 5.898 5.898 0 01-2.996-.79 5.86 5.86 0 01-2.162-2.13A5.833 5.833 0 010 5.949c0-1.083.267-2.082.801-2.996A5.867 5.867 0 012.974.79 5.898 5.898 0 015.97 0c1.083 0 2.085.27 3.007.812a5.8 5.8 0 012.118 2.151c.52.907.779 1.902.779 2.985a6.1 6.1 0 01-.362 2.096 5.427 5.427 0 01-1.043 1.767l.242.263h.746z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M21-5H-6v27h27z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e5c9d180.svg";
export { ForwardRef as ReactComponent };